export const switcherStyles = {
  noSelectBg: '#d9d9d9',
};
